import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from 'mdoc/utils/table/TableHead';
import TablePage from 'mdoc/utils/table/TablePage';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import DateFnsUtils from '@date-io/date-fns';
import zhCNLocale from 'date-fns/locale/zh-CN';
import jaLocale from 'date-fns/locale/ja';
import enLocale from 'date-fns/locale/en-US';
import { MuiPickersUtilsProvider, DateTimePicker, DatePicker, TimePicker } from 'material-ui-pickers';
import { Tooltip, TextField } from '@material-ui/core';
import { getLang, dateFormat } from 'mdoc/utils';
const localeMap = {
    1: jaLocale,
    2: zhCNLocale,
    3: enLocale,
};
const lang = getLang();

const CustomTableCell = withStyles(theme => ({
    head: theme.palette.table.header,
    body: theme.palette.table.body,
    root: {
        padding: '0px 0px 0px 20px',
        fontSize: 12
    },
}))(TableCell);

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
});


class CustomizedTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editable: [],
            dateTime: null,
            tipsOpen: false
        };
    }

    handleCellClick(row, cell, event) {
        let editable = [];
        editable[row + '-' + cell] = true;
        this.setState({
            editable: editable
        });
    }
    handleCellBlur(event) {
        this.setState({
            editable: []
        });
    }
    validate(validate, value) {
        value = value.trim();
        if (validate) {
            let result = {
                error: false,
                errorMessage: ''
            };
            for (let item in validate) {
                if (item === 'required') {
                    if (!value && value.length < 1) {
                        result = {
                            error: true,
                            errorMessage: validate[item]
                        };
                        break;
                    }
                }
                if (item === 'maxlength') {
                    if (value.length > validate[item].value) {
                        result = {
                            error: true,
                            errorMessage: validate[item].errorMsg
                        };
                        break;
                    }
                }
                if (item === 'number') {
                    let reg = new RegExp("^[^0-9]*$");
                    if (reg.test(value)) {
                        result = {
                            error: true,
                            errorMessage: validate[item].number
                        };
                        break;
                    }
                }
                if (item === 'other') {
                    let other = validate[item](value);
                    result = other;
                    break;
                }
            }
            return result;
        } else {
            return {
                error: false,
                errorMessage: ''
            };
        }
    }
    handleChange(row, cell, column, event) {
        let oldData = this.props.data;
        let newData = Object.assign({}, oldData);
        let value = event ? event.target !== undefined ? event.target.value : dateFormat(new Date(event), 'yyyy/MM/dd') : '';
        let errorMessage = {};
        if (column.validate) {
            errorMessage = this.validate(column.validate, value);
        }
        newData[row][column.dataIndex] = value;
        this.props.editable.onCellUpdate(row, newData[row], oldData[row], errorMessage);
    }
    setDate = (dateTime) => this.setState({ dateTime })
    handleMouseOver(index) {
        let target = document.getElementById(index);
        let offsetWidth = target.offsetWidth;
        let scrollWidth = target.scrollWidth;
        if (offsetWidth < scrollWidth) {
            let tipsOpen = {};
            tipsOpen[index] = true;
            this.setState({
                tipsOpen
            });
        }
    }
    handleMouseOut() {
        let tipsOpen = {};
        this.setState({
            tipsOpen
        });
    }

    render() {
        const { classes, columns, data, noPage, page, count, rowsPerPage, onChange, sord, sidx, onSort, errorMsg, editable } = this.props;
        return (
            <Paper className={classes.root}>
                <Table className={classes.table}>
                    <TableHead
                        columns={columns}
                        sord={sord}
                        sidx={sidx}
                        onSort={onSort}
                    />
                    <TableBody>
                        {(data && data !== undefined && data.length > 0) ? data.map((row, i) => {
                            return (<TableRow className={classes.row} key={i}>{
                                columns.map((column, j) => {
                                    let render = '';
                                    if (column.render) {
                                        render = column.render(row[column.dataIndex], row, i);
                                    } else {
                                        render = row[column.dataIndex];
                                    }
                                    if (!this.state.editable[i + '-' + j] && render !== undefined) {
                                        if (column.type && column.type === 'select') {
                                            render = column.datasource[render];
                                        }
                                        if (column.toolTipDisabled !== true) {
                                            render = <Tooltip placement="bottom-start" disableFocusListener open={this.state.tipsOpen[i + '-' + j] === true} title={render}><span>{render}</span></Tooltip>;
                                        }
                                    }
                                    let style = Object.assign({
                                        minWidth: '70px',
                                        width: '20%',
                                        maxWidth: '120px',
                                        overflow: 'hidden',
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis'
                                    },column['style']);
                                    
                                    if (column['width']) {
                                        let width = parseInt(column['width'].replace('px',''));
                                        style['width'] = column['width'];
                                        style['minWidth'] = column['width'];
                                        style['maxWidth'] = (width+50)+'px';
                                    }
                                    if (column['minWidth']) {
                                        style['minWidth'] = column['minWidth'];
                                    }
                                    if (column['maxWidth']) {
                                        style['maxWidth'] = column['maxWidth'];
                                    }
                                    if (column['textAlign']) {
                                        style['textAlign'] = column['textAlign'];
                                    }

                                    if (editable) {
                                        switch (column.type) {
                                            case 'text':
                                                return <CustomTableCell id={i + '-' + j} onMouseOver={this.handleMouseOver.bind(this, i + '-' + j)} onMouseOut={this.handleMouseOut.bind(this)} onClick={this.handleCellClick.bind(this, i, j)} onBlur={this.handleCellBlur.bind(this)} padding="dense" component="td" scope="row" key={j} style={style}>
                                                    {this.state.editable[i + '-' + j] ?
                                                        <TextField
                                                            value={render}
                                                            name={column.dataIndex}
                                                            id={i + '-' + j}
                                                            autoFocus
                                                            onChange={this.handleChange.bind(this, i, j, column)}
                                                        />
                                                        :
                                                        render}
                                                </CustomTableCell>;
                                            case 'select':
                                                let options = [];
                                                for (let key in column.datasource) {
                                                    let item = column.datasource[key];
                                                    options.push(<option key={key} value={key}>{item}</option>);
                                                }
                                                return <CustomTableCell id={i + '-' + j} onMouseOver={this.handleMouseOver.bind(this, i + '-' + j)} onMouseOut={this.handleMouseOut.bind(this)} onClick={this.handleCellClick.bind(this, i, j)} onBlur={this.handleCellBlur.bind(this)} padding="dense" component="td" scope="row" key={j} style={style}>
                                                    {this.state.editable[i + '-' + j] ?
                                                        <TextField
                                                            select
                                                            value={render}
                                                            name={column.dataIndex}
                                                            id={i + '-' + j}
                                                            autoFocus
                                                            onChange={this.handleChange.bind(this, i, j, column)}
                                                            SelectProps={{
                                                                native: true,
                                                            }}
                                                        >
                                                            {options}
                                                        </TextField>
                                                        : render}
                                                </CustomTableCell>;
                                            case 'dateTime':
                                                return <CustomTableCell id={i + '-' + j} onMouseOver={this.handleMouseOver.bind(this, i + '-' + j)} onMouseOut={this.handleMouseOut.bind(this)} onClick={this.handleCellClick.bind(this, i, j)} padding="dense" component="td" scope="row" key={j} style={style}>
                                                    {this.state.editable[i + '-' + j] ?
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[lang]}>
                                                            <DateTimePicker ampm={false} format={column.format ? column.format : "yyyy/MM/dd hh:mm"} value={render ? render : null} onChange={this.handleChange.bind(this, i, j, column)} clearable />
                                                        </MuiPickersUtilsProvider>
                                                        :
                                                        render}
                                                </CustomTableCell>;
                                            case 'date':
                                                return <CustomTableCell id={i + '-' + j} onMouseOver={this.handleMouseOver.bind(this, i + '-' + j)} onMouseOut={this.handleMouseOut.bind(this)} onClick={this.handleCellClick.bind(this, i, j)} padding="dense" component="td" scope="row" key={j} style={style}>
                                                    {this.state.editable[i + '-' + j] ?
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[lang]}>
                                                            <DatePicker format={column.format ? column.format : "yyyy/MM/dd"} value={render ? render : null} onChange={this.handleChange.bind(this, i, j, column)} clearable />
                                                        </MuiPickersUtilsProvider>
                                                        :
                                                        render}
                                                </CustomTableCell>;
                                            case 'time':
                                                return <CustomTableCell id={i + '-' + j} onMouseOver={this.handleMouseOver.bind(this, i + '-' + j)} onMouseOut={this.handleMouseOut.bind(this)} onClick={this.handleCellClick.bind(this, i, j)} padding="dense" component="td" scope="row" key={j} style={style}>
                                                    {this.state.editable[i + '-' + j] ?
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[lang]}>
                                                            <TimePicker ampm="false" format={column.format ? column.format : "hh:mm"} value={render ? render : null} onChange={this.handleChange.bind(this, i, j, column)} clearable />
                                                        </MuiPickersUtilsProvider>
                                                        :
                                                        render}
                                                </CustomTableCell>;
                                            default:
                                                return <CustomTableCell id={i + '-' + j} onMouseOver={this.handleMouseOver.bind(this, i + '-' + j)} onMouseOut={this.handleMouseOut.bind(this)} padding="dense" component="td" scope="row" key={j} style={style}>
                                                    {render}
                                                </CustomTableCell>;
                                        }
                                    } else {
                                        return <CustomTableCell id={i + '-' + j} onMouseOver={this.handleMouseOver.bind(this, i + '-' + j)} onMouseOut={this.handleMouseOut.bind(this)} padding="dense" component="td" scope="row" key={j} style={style}>
                                            {render}
                                        </CustomTableCell>;
                                    }
                                })
                            }</TableRow>);
                        }) : <TableRow><CustomTableCell align="center" colSpan={columns.length} component="td" scope="row" style={{ width: '100%' }}>{errorMsg ? errorMsg : ''}</CustomTableCell></TableRow>}
                    </TableBody>
                    {noPage ? null :
                        <TablePage
                            count={count}
                            columnsCount={columns.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onChange={onChange}
                        />}
                </Table>
            </Paper >
        );
    }
}

CustomizedTable.propTypes = {
    classes: PropTypes.object.isRequired,
    columns: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    noPage: PropTypes.bool,
    editable: PropTypes.object,
    page: PropTypes.number,
    rowsPerPage: PropTypes.number,
    count: PropTypes.number,
    onChange: PropTypes.func,
    sord: PropTypes.string,
    sidx: PropTypes.string,
    onSort: PropTypes.func,
    errorMsg: PropTypes.string,
};

export default withStyles(styles)(CustomizedTable);